// 公告「已讀（知道了）／已顯示」記錄的保留規則。刻意零 import，讓 Vitest 能以相對路徑直接載入。
//
// 已讀記錄不能用「是否還在當前公告顯示清單中」當清理依據：該清單會因登出（清成空陣列）、
// 切換店家、app/web 平台差異而變動，拿它當依據會誤刪已讀，重新登入後同一則公告又主動彈出。
// endTime 為 null 的永久公告沒有到期時間讓它自然消失，被誤刪等於「知道了」永久失效。

// 記錄保留上限。改以過期為唯一清理依據後，永久公告不會被時間清掉，靠上限避免無限累積。
export const MAX_ANNOUNCEMENT_RECORDS = 200

// endTime 為 null（永久公告）或無效日期，一律視為「仍需隱藏」
export function isStillHiding(endTime, now) {
	if (endTime == null) return true
	const end = new Date(endTime)
	return Number.isNaN(end.getTime()) ? true : end > now
}

// 已讀清單：只移除公告本身已過期者，再截斷長度
export function pruneHiddenAnnouncements(hiddenAnnouncements, now) {
	return (Array.isArray(hiddenAnnouncements) ? hiddenAnnouncements : [])
		.filter(hidden => isStillHiding(hidden?.endTime, now))
		.slice(-MAX_ANNOUNCEMENT_RECORDS)
}

// 已顯示清單：session 級（冷啟動重置），沒有過期時間可判斷，僅截斷長度
export function pruneShownAnnouncements(shownAnnouncements) {
	return (Array.isArray(shownAnnouncements) ? shownAnnouncements : []).slice(
		-MAX_ANNOUNCEMENT_RECORDS,
	)
}
